import { render, staticRenderFns } from "./PopupStatistcGraph.vue?vue&type=template&id=f94d6fce&scoped=true"
import script from "./PopupStatistcGraph.vue?vue&type=script&lang=js"
export * from "./PopupStatistcGraph.vue?vue&type=script&lang=js"
import style0 from "./PopupStatistcGraph.vue?vue&type=style&index=0&id=f94d6fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94d6fce",
  null
  
)

export default component.exports